import { render, staticRenderFns } from "./ScatterplotContainer.vue?vue&type=template&id=07c0ca5b&"
import script from "./ScatterplotContainer.vue?vue&type=script&lang=js&"
export * from "./ScatterplotContainer.vue?vue&type=script&lang=js&"
import style0 from "./ScatterplotContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports